import { render, staticRenderFns } from "./TaskAddedFollowers.vue?vue&type=template&id=f2fba8a2&scoped=true"
import script from "./TaskAddedFollowers.vue?vue&type=script&lang=js"
export * from "./TaskAddedFollowers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fba8a2",
  null
  
)

export default component.exports